import React, { Fragment } from 'react';

const CategoryLink = ({ links = [] }) => {
    function toggleMenu(index, link) {
        const navbar = document.getElementById('navbar');
        const menuCtaLinks = document
            .getElementsByClassName('cta-header-links')[0]
            .getElementsByClassName('navbar__item');
        document
            .querySelectorAll('.navbar__item.image-column-holder')
            .forEach(x => x.classList.remove('hidden'));
        document
            .querySelectorAll('.navbar__menu.navbar__menu--show')
            .forEach(x => x.classList.remove('navbar__menu--show'));

        if (navbar && navbar.getElementsByClassName('navbar__menu')) {
            let menus = navbar.getElementsByClassName('navbar__menu');
            menus[0].classList.add('navbar__menu--show');
            let ctaNavLinks = navbar.getElementsByClassName('cta-menu-link');
            for (var i = 0; i < ctaNavLinks.length; i++) {
                let ctaMenu =
                    ctaNavLinks[i].getElementsByClassName('navbar__menu')[0];
                if (ctaMenu && i === index) {
                    menuCtaLinks[i].classList.add('active');
                    ctaMenu.classList.add('navbar__menu--show');
                } else if (ctaMenu) {
                    menuCtaLinks[i].classList.remove('active');
                    ctaMenu.classList.remove('navbar__menu--show');
                }
            }
        }
    }

    if (links.length === 0) return null;

    // Display only 3 first cta items (Woman, Man, Tools)
    return (
        <div className="cta-header-links mobile-show">
            {links.length > 0 &&
                links
                    .filter(x => x.cta)
                    .slice(0, 3)
                    .map(
                        (link, index) =>
                            link.name !== '' && (
                                <li
                                    className="navbar__item mobile-only"
                                    key={link.url + link.name}
                                    onClick={() => {
                                        toggleMenu(index, link);
                                    }}
                                >
                                    <a className="navbar__link" href="#">
                                        {link.name}
                                    </a>
                                </li>
                            ),
                    )}
        </div>
    );
};

export default CategoryLink;
